import { createIndentPlugin, createAlignPlugin } from '@udecode/plate';
import { CONFIG } from '../config/config';
import { plateComponentUI } from '../config/plateComponentUI';
import { createMyPlugins } from '../config/typescript';

export const alignPlugins = createMyPlugins([createIndentPlugin(CONFIG.indent), createAlignPlugin(CONFIG.align)], {
  components: plateComponentUI,
});
